import { DateTime } from "luxon";
import { api1 } from "../utils/axiosInstance";

export const createBookAppointmentServices = async (payload) => {
  const localZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // 2. Pull out the pieces you need
  const { date: isoDate, selectedTime } = payload.bookedAppointment;
  const [startStr, endStr] = selectedTime.split(" - "); // e.g. ["00:15", "00:30"]

  // 3. Parse the date in the local zone…
  const base = DateTime.fromISO(isoDate, { zone: localZone });

  // 4. Build two DateTimes (start + end) and shift them to UTC
  const startUTC = base
    .set({
      hour: parseInt(startStr.split(":")[0], 10),
      minute: parseInt(startStr.split(":")[1], 10),
    })
    .toUTC()
    .toISO(); // e.g. "2025-04-29T19:15:00.000Z"

  const endUTC = base
    .set({
      hour: parseInt(endStr.split(":")[0], 10),
      minute: parseInt(endStr.split(":")[1], 10),
    })
    .toUTC()
    .toISO(); // e.g. "2025-04-29T19:30:00.000Z"

  const payloadUTC = {
    mentorId: payload.mentorId,
    bookedAppointment: {
      comments: payload.bookedAppointment.comments,
      date: startUTC,
      selectedTime: `${startUTC} - ${endUTC}`,
      meetingForTime: payload.bookedAppointment.meetingForTime,
      status: payload.bookedAppointment.status,
    },
    payment: payload.payment,
  };

  try {
    const response = await api1.post("/api/appointment", payloadUTC);
    return response.data.data;
  } catch (error) {
    console.error(
      "Error while posting appointment:",
      error.response || error.message
    );
    return null;
  }
};
